import React from 'react';
export function Footer() {
  return <footer className="bg-white py-12 border-t border-neutral-200" data-id="element-71">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-72">
        <div className="flex items-center gap-2" data-id="element-73">
          <div className="w-5 h-5 bg-foreground rounded-sm flex items-center justify-center" data-id="element-74">
            <div className="w-1.5 h-1.5 bg-background rounded-full" data-id="element-75" />
          </div>
          <span className="font-serif text-lg font-medium tracking-tight" data-id="element-76">
            Inflect
          </span>
        </div>

        <div className="flex gap-6 text-sm text-neutral-500" data-id="element-77">
          <a href="#" className="hover:text-foreground transition-colors" data-id="element-78">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-foreground transition-colors" data-id="element-79">
            Terms of Service
          </a>
        </div>

        <div className="text-sm text-neutral-400" data-id="element-80">
          © 2026 Anthropify Consulting. All rights reserved.
        </div>
      </div>
    </footer>;
}